<template>
  <v-card class="manageCodeList col-12 mt-7 mb-4 pb-0">
    <div class="row justify-end mt-0 mb-0">
      <div class="row justify-start mt-0 mb-0" style="padding-left: 25px;">
        <v-btn small color="grey darken-4" class="white--text" @click="removeCode()">정품인증코드 파기</v-btn>
      </div>

      <div
        v-if="$store.state.mode !== AUTH_SERVICE.APP_MODE.PLUS"
        class="v-btn disabledBtn"
        @click.prevent="checkVersionAlret"
      >정품 QR코드 인쇄</div>
      <v-btn v-else small color="blue" class="white--text">정품 QR코드 인쇄</v-btn>
      <v-btn
        small
        color="green"
        class="white--text ml-3 mr-3"
        @click.prevent="excelDownload"
      >엑셀 다운로드</v-btn>
    </div>

    <v-data-table
      v-model="selectedProduct"
      :headers="headers"
      :items="productInfos"
      :server-items-length="productInfosCount"
      :options.sync="options"
      :loading="tableLoading"
      calculate-widths
      show-select
      :items-per-page="$parent.$refs.searchComponent.searchPayload.limit"
      :footer-props="{
        'items-per-page-options': [10, 20, 30, 40, 50],
        'items-per-page-text': '목록 노출 수 선택:',
      }"
      item-key="serial_number"
      scrollable
    >
      <template v-slot:item.created="{ item }">
        <p
          class="mb-0 mt-3 text-center caption"
          v-html="$options.filters.defaultDate(item.created_at)"
        ></p>
      </template>

      <template v-slot:item.authCode="{ item }">
        <p class="mb-0 mt-3 caption" @click="authCodeClick(item)">
          <a>{{ item.serial_number }}</a>
        </p>
      </template>

      <template v-slot:item.image="{ item }" class="pl-0 pr-0 ml-0 mr-0">
        <v-row no-gutters>
          <v-col>
            <v-img v-if="item.list_image" :src="item.list_image" width="60px" height="60px"></v-img>
            <v-img v-else :src="adminDefaultImg" width="60px" height="60px"></v-img>
          </v-col>
        </v-row>
      </template>

      <template v-slot:item.productInfo="{ item }" class="pl-0 pr-0 ml-0 mr-0">
        <v-row no-gutters>
          <v-col
            :cols="12"
            class="pl-0 pr-0 ml-0 mr-0"
            style="width:170px;overflow: hidden; text-overflow: ellipsis; ; white-space: nowrap;"
          >
            <p class="mb-0 mt-3 mr-0 text-left text-truncate caption">{{ item.product_name }}</p>
            <p class="mb-0 mr-0 text-left text-truncate caption">옵션 : {{ item.variant_name }}</p>
            <p class="mb-0 mr-0 text-left text-truncate caption">상품코드 : {{ item.product_code }}</p>
            <p class="mb-3 mr-0 text-left text-truncate caption">품목코드 : {{ item.variant_code }}</p>
          </v-col>
        </v-row>
      </template>

      <template v-slot:item.warrantyPeriodDays="{ item }" class="pl-0 pr-0">
        <a
          @click="daysClick(item)"
          class="caption"
          v-html="
            $options.filters.warrantyPeriod({
              cert_status: item.cert_status,
              cert_duration_type: item.cert_duration_type,
              cert_duration: item.cert_duration,
              cert_validated_at: item.cert_validated_at,
              cert_expired_at: item.cert_expired_at,
            })
          "
        ></a>
      </template>

      <template v-slot:item.authState="{ item }" class="pl-0 pr-0">
        <p class="mb-0">
          <a @click="authStateClick(item)" class="caption">{{ item.cert_status | certStatus }}</a>
        </p>
      </template>

      <template v-slot:item.authDate="{ item }" class="pl-0 pr-0">
        <p
          class="mb-0 text-center caption"
          v-html="$options.filters.defaultDate(item.activated_at)"
        ></p>
      </template>

      <template v-slot:item.authUserId="{ item }" class="pl-0 pr-0">
        <p class="mb-0 text-center caption">
          <a v-if="item.member_id !== null" target="_blank">{{ item.member_id | defaultString }}</a>
          <span v-else>{{ item.member_id | defaultString }}</span>
        </p>
      </template>
      <template slot="no-data">
        <div class="noDataProductInfos">내역이 없습니다.</div>
      </template>
    </v-data-table>

    <!--
      Modal
    -->
    <v-row justify="center">
      <v-dialog persistent max-width="310" v-model="removeConfirm">
        <v-card>
          <v-card-title class="headline"></v-card-title>
          <v-card-text>
            <p class="mb-0">선택하신 정품인증코드를 파기하시면</p>
            <p class="mb-0">관련된 이력과 함께 모두 사라지게 됩니다.</p>
            <p class="mb-0">정말로 파기하시겠습니까?</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="black darken-1" text @click.prevent="removeConfirm = false">취소</v-btn>
            <v-btn color="blue darken-1" @click.prevent="sendRemoveCode" text>파기</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <AuthCodeClickModal ref="AuthCodeClickModal"></AuthCodeClickModal>
    <QrCodePrintModal ref="QrCodePrintModal"></QrCodePrintModal>
    <AuthWarrantyPeriodChangeModal ref="AuthWarrantyPeriodChangeModal"></AuthWarrantyPeriodChangeModal>
    <UnAuthWarrantyPeriodChangeModal ref="UnAuthWarrantyPeriodChangeModal"></UnAuthWarrantyPeriodChangeModal>
    <AuthStateChangeModal ref="AuthStateChangeModal"></AuthStateChangeModal>
  </v-card>
</template>
<style scoped>
.noDataProductInfos {
  padding: 50px 0;
}
.manageCodeList a:hover {
  text-decoration: underline;
}
.disabledBtn {
  height: 28px;
  min-width: 50px;
  padding: 0 12.4444444444px;
  font-size: 0.75rem;
  background-color: #f5f5f5;
  color: #bababa;
}
</style>
<script>
import M from "@/libs/mapping.js";
import { AUTH_SERVICE } from "@/datas/authservice";
import CommonMixin from "@/mixins/CommonMixin.js";
import Filters from "@/libs/authservice/filters.js";
import AuthCodeClickModal from "@/components/shoplus_authservice/authcode/modal/AuthCodeClickModal.vue";
import QrCodePrintModal from "@/components/shoplus_authservice/authcode/modal/QrCodePrintModal.vue";
import AuthWarrantyPeriodChangeModal from "@/components/shoplus_authservice/authcode/modal/AuthWarrantyPeriodChangeModal.vue";
import UnAuthWarrantyPeriodChangeModal from "@/components/shoplus_authservice/authcode/modal/UnAuthWarrantyPeriodChangeModal.vue";
import AuthStateChangeModal from "@/components/shoplus_authservice/authcode/modal/AuthStateChangeModal.vue";
import Excel from "@/libs/excel.js";

export default {
  data() {
    return {
      AUTH_SERVICE,
      headers: [
        {
          text: "생성일시",
          align: "center",
          sortable: false,
          value: "created",
          width: 100
        },
        {
          text: "정품인증코드",
          align: "center",
          value: "authCode",
          sortable: false,
          width: 180
        },
        {
          text: "이미지",
          align: "center",
          value: "image",
          sortable: false,
          width: 70
        },
        {
          text: "품목 정보",
          align: "center",
          value: "productInfo",
          sortable: false
        },
        {
          text: "인증상태",
          align: "center",
          value: "authState",
          sortable: false,
          width: 90
        },
        {
          text: "보증기간",
          align: "center",
          value: "warrantyPeriodDays",
          sortable: false,
          width: 120
        },
        {
          text: "인증일시",
          align: "center",
          value: "authDate",
          sortable: false,
          width: 100
        },
        {
          text: "인증회원ID",
          value: "authUserId",
          sortable: false,
          width: 100
        }
      ],
      selectedProduct: [],
      removeConfirm: false,
      productInfos: [],
      productInfosCount: 0,
      options: {},
      tableLoading: false,
      excelData: {
        Excel: null,
        totalLimit: 200000,
        limit: 10000,
        totalCount: 0,
        offset: 0,
        sheetData: [],
        sheetHeader: {
          created_at: "생성일시",
          serial_number: "정품인증코드",
          list_image: "이미지",
          product_name: "상품명",
          variant_name: "품목명",
          product_code: "상품코드",
          variant_code: "품목코드",
          custom_product_code: "자체상품코드",
          custom_variant_code: "자체품목코드",
          cert_duration_type: "보증기간",
          cert_status: "인증상태",
          activated_at: "인증일시",
          member_id: "인증회원ID"
        }
      },
      printSettingInfo: "N",
      adminDefaultImg: require("../../../assets/authservice/images/admin_default.png")
    };
  },
  components: {
    AuthCodeClickModal,
    QrCodePrintModal,
    AuthWarrantyPeriodChangeModal,
    UnAuthWarrantyPeriodChangeModal,
    AuthStateChangeModal
  },
  mixins: [CommonMixin],
  filters: Filters,
  created: async function() {
    //같은 자식 컴포넌트로 부터 setList 을 emit 한 함수를 on 으로 받아 setProductList 메소드 호출
    this.eventHub.$on("setList", this.setProductList);

    try {
      let data = await M.api(M.entry("/get/print"), {});
      if (data) {
        if (
          data.print_paper == "60*48mm a4 라벨지 (일반프린터)" ||
          data.print_paper == "선택해주세요."
        ) {
          data.print_paper = "";
        }
        if (
          data.print_template == "타입1" ||
          data.print_template == "선택해주세요."
        ) {
          data.print_template = "";
        }

        if (data.print_paper && data.print_template) {
          this.printSettingInfo = "Y";
        }
      }
    } catch (e) {
      this.printSettingInfo = "N";
    }
  },
  watch: {
    options: {
      handler() {
        this.$parent.$refs.searchComponent.execSearch(false);
      },
      deep: true
    }
  },
  methods: {
    setProductList: function(data) {
      this.selectedProduct = [];
      this.productInfosCount = data.count;
      this.productInfos = data.serials;
      this.tableLoading = false;
    },
    authCodeClick: function(data) {
      this.$refs.AuthCodeClickModal.authCodeClick(data);
    },
    daysClick: function(data) {
      this.$refs.UnAuthWarrantyPeriodChangeModal.warrantyPeriodClick(data);
    },
    authStateClick: function(data) {
      this.$refs.AuthStateChangeModal.authStateClick(data);
    },
    /**
     * 엑셀 다운로드 체크
     */
    excelDownload: async function() {
      this.excelData.totalCount = 0;
      this.excelData.offset = 0;
      let excelPayload = this.$parent.$refs.searchComponent.$data.searchPayload;
      excelPayload["limit"] = this.excelData.limit;
      excelPayload["offset"] = 0;

      let data = await M.api(M.entry("/cert/serials/search"), excelPayload);
      if (data.length === 0) {
        this.alertShow("엑셀다운로드할 데이터가 없습니다.");
        return false;
      }
      this.excelData.totalCount = data.count;
      if (this.excelData.totalCount > this.excelData.totalLimit) {
        this.alertShow(
          "엑셀다운로드건수는 " +
            this.$options.filters.numberFormat(this.excelData.totalLimit) +
            "건</br>이내로 검색하여 다운로드 해주세요."
        );
        return false;
      }
      this.excelData.sheetData = data.serials;
      this.checkExcelDataChange();
      this.initExcelDownload();
    },
    /**
     * 엑셀 시작
     */
    initExcelDownload: function() {
      let progressText = "엑셀 다운로드중입니다.</br>잠시만 기다려 주세요.";
      this.circularProgressShow(progressText);
      // this.defaultProgressShow();
      this.excelData.Excel = new Excel(null, this.excelData.sheetHeader);
      this.addExcel();
    },
    /**
     * 엑셀 추가 데이터
     */
    getExcelDataAdd: async function() {
      this.excelData.offset = this.excelData.offset + this.excelData.limit;
      this.circularProgressSetValue(
        Math.round((this.excelData.offset / this.excelData.totalCount) * 100)
      );
      if (this.excelData.offset > this.excelData.totalCount) {
        await this.endExcel();
        return false;
      }
      let excelPayload = this.$parent.$refs.searchComponent.$data.searchPayload;
      excelPayload["limit"] = this.excelData.limit;
      excelPayload["offset"] = this.excelData.offset;
      let data = await M.api(M.entry("/cert/serials/search"), excelPayload);
      if (data.length === 0) {
        await this.endExcel();
        return false;
      }
      this.excelData.sheetData = data.serials;
      this.checkExcelDataChange();
      this.excelData.Excel.addSheet(this.excelData.sheetData);
      this.addExcel();
    },
    /**
     * 시트에 엑셀 추가
     */
    addExcel: async function() {
      if (this.excelData.offset === 0) {
        await this.excelData.Excel.initSheet();
        await this.excelData.Excel.addSheet(this.excelData.sheetData);
        await this.getExcelDataAdd();
      } else {
        await this.getExcelDataAdd();
      }
    },
    /**
     * 파일 다운
     */
    endExcel: async function() {
      setTimeout(() => {
        this.circularProgressHide();
      }, 1500);
      // this.defaultProgressHide();
      let toDay = new Date();
      let year = toDay.getFullYear();
      let month = 1 + toDay.getMonth();
      month = month >= 10 ? month : "0" + month;
      let day = toDay.getDate();
      day = day >= 10 ? day : "0" + day;
      await this.excelData.Excel.endSheet(
        `${year}${month}${day}_${this.$store.state.mallId}`
      );
    },
    /**
     * excel데이터 변경
     */
    checkExcelDataChange: function() {
      if (this.excelData.sheetData.length > 0) {
        this.excelData.sheetData.forEach(data => {
          for (let key in data) {
            if (key === "cert_status") {
              data[key] = this.$options.filters.certStatus(data[key]);
            }
            if (key === "cert_duration_type") {
              data[key] = this.$options.filters
                .warrantyPeriod(data)
                .replace("</br>", "");
            }
          }
        });
      }
    },
    removeCode: async function() {
      if (this.selectedProduct.length === 0) {
        this.alertShow("파기하실 정품 인증 코드를 선택해주세요.");
      } else {
        this.removeConfirm = true;
      }
    },
    sendRemoveCode: async function() {
      let payload = {
        serial_numbers: []
      };
      payload["serial_numbers"] = this.selectedProduct.map(
        item => item.serial_number
      );
      try {
        await M.api(M.entry("/serials/del"), payload);
        this.removeConfirm = false;
        this.eventHub.$emit("execSearch", false);
      } catch (e) {
        this.removeConfirm = false;
        this.alertShow("현재 서버 통신이 불안정합니다. 잠시 후 사용해주세요.");
      }
    },
    checkVersionAlret: function() {
      let msg =
        "해당 메뉴는 '플러스 버전' 에서 사용이 가능합니다.</br>[결제관리] 메뉴에서 버전을 변경/결제하여 사용해주세요.";
      this.alertShow(msg);
    }
  }
};
</script>
